// GLightbox on-demand
if (document.querySelector('.glightbox')) {
  import('./GLightbox').then(({ initGLightbox }) => initGLightbox());
}

// Infinite Scroll on-demand
document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('#product-grid');
  console.log('[infinite] grid?', !!grid);
  if (!grid) return;

  const nextA = grid.querySelector('.pagination__next');
  console.log('[infinite] next href:', nextA?.href);

  import('./infiniteScroll').then(({ initInfiniteScroll }) => {
    initInfiniteScroll(grid);
    console.log('[infinite] init done');
  });
});

// Dropzone on-demand
if (document.getElementById('DropzoneImgUpload')) {
  import('./dropzone').then(({ initDropzone }) => initDropzone());
}

// Pré-layout movido para SwiperPlaceholder.js para centralizar a lógica

function onReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  } else {
    fn();
  }
}

onReady(() => {
  const hasSwiper = document.querySelector('.swiper');

  if (hasSwiper) {
    console.debug('[Swiper] detectado, importando módulo...');

    import('./swiper/index.js') // Caminho completo e explícito ajuda o Vite no build
      .then(({ initSwipers }) => {
        console.debug('[Swiper] módulo carregado, inicializando...');
        initSwipers?.();
      })
      .catch(err => {
        console.error('[Swiper] falhou ao carregar:', err);
      });
  } else {
    console.debug('[Swiper] nenhum carrossel encontrado nesta página.');
  }
});
